
const studyCenterRouters = [
	{
		path: '/StudyCenter',
		name: 'studyCenter_home',
		component: () => import('@/views/StudyCenter/index.vue'),
		meta: {
			isCorrectPage: true,
			auth: false,
			// isPlayAudio:false,
		}
	},
	{
		path: '/Review',
		name: 'StudyCenter_Review',
		redirect: '/Review/ReviewList',
		component: () => import('@/views/StudyCenter/Review/index.vue'),
		meta: {
			// keepAlive: true,
			isCorrectPage: true,
			auth: false,
			isPlayAudio:false,
			isStudyTitle:true,//学习中心的头部
		},
		children: [
			{
				path: 'ReviewList',
				name: 'StudyCenter_Review_ReviewList',
				component: () => import('@/views/StudyCenter/Review/pages/home.vue'),
				meta: {
					isCorrectPage: true,
					auth: false,
					isPlayAudio:false,
					isStudyTitle:true,//学习中心的头部
				},
			},
			{
				path: 'PrevList',
				name: 'StudyCenter_Review_PrevList',
				component: () => import('@/views/StudyCenter/Review/pages/prevList.vue'),
				meta: {
					isCorrectPage: true,
					auth: false,
					isPlayAudio:false,
					isStudyTitle:true,//学习中心的头部
				},
			},
			{
				path: 'ReviewMap',
				name: 'StudyCenter_Review_ReviewMap',
				component: () => import('@/views/StudyCenter/Review/pages/maps.vue'),
				meta: {
					keepAlive: true,
					isCorrectPage: true,
					auth: false,
					isPlayAudio:false,
					isStudyTitle:true,//学习中心的头部
				},
			},
			{
				path: 'ReviewQuestions',
				name: 'StudyCenter_Review_ReviewQuestions',
				component: () => import('@/views/StudyCenter/Review/pages/questions.vue'),
				meta: {
					// keepAlive: true,
					isCorrectPage: true,
					auth: false,
					isPlayAudio:false,
					isStudyTitle:true,//学习中心的头部
				},
			}
		]
	},
	{
		path: '/Classroom',
		name: 'StudyCenter_Classroom',
		component: () => import('@/views/StudyCenter/Classroom/index.vue'),
		redirect: '/Classroom/RoomType',
		children: [
			{
				path: 'ClassList',
				name: 'StudyCenter_Classroom_ClassList',
				component: () => import('@/views/StudyCenter/Classroom/pages/classList.vue'),
				meta: {
					isCorrectPage: true,
					auth: false,
					isPlayAudio:false,
					isStudyTitle:true,//学习中心的头部
				},
			},
			{
				path: 'RoomType',
				name: 'StudyCenter_Classroom_RoomType',
				component: () => import('@/views/StudyCenter/Classroom/pages/home.vue'),
				meta: {
					isCorrectPage: true,
					auth: false,
					isPlayAudio:false,
					isStudyTitle:true,//学习中心的头部
				},
			},
			{
				path: 'ClassVideo',
				name: 'StudyCenter_Classroom_ClassVideo',
				component: () => import('@/views/StudyCenter/Classroom/pages/classVideo.vue'),
				meta: {
					isCorrectPage: true,
					auth: false,
					isPlayAudio:false,
					isStudyTitle:true,//学习中心的头部
				},
			},
		]
	},
	{
		path: '/ReviewMaps',
		name: 'StudyCenter_ReviewMap',
		component: () => import('@/views/StudyCenter/Review/reviewMaps.vue'),
		meta: {
			keepAlive: true,
			canUpdate: false,
			isCorrectPage: true,
			auth: true,
			isPlayAudio:false,
			isStudyTitle:true, // 学习中心的头部
		},
	},
	{
		path: '/Mp3',
		name: 'StudyCenter_Mp3',
		redirect: '/Mp3/Mp3List',
		component: () => import('@/views/StudyCenter/Mp3/index.vue'),
		meta: {
			isCorrectPage: true,
			auth: false,
			isPlayAudio:false,
			isStudyTitle:true,//学习中心的头部
		},
		children: [
			{
				path: 'Mp3List',
				name: 'StudyCenter_Mp3_Mp3List',
				component: () => import('@/views/StudyCenter/Mp3/pages/home.vue'),
				meta: {
					isCorrectPage: true,
					auth: false,
					isPlayAudio:false,
					isStudyTitle:true,//学习中心的头部
				},
			},
			{
				path: 'Mp3Questions',
				name: 'StudyCenter_Mp3_Mp3Questions',
				component: () => import('@/views/StudyCenter/Mp3/pages/questions.vue'),
				meta: {
					isCorrectPage: true,
					auth: false,
					isPlayAudio:false,
					isStudyTitle:true,//学习中心的头部
				},
			}
		]
	},
	{
		path: '/BookOutlink',
		name: 'StudyCenter_BookOutlink',
		component: () => import('@/views/StudyCenter/Book/bookOutlink.vue'),
		meta: {
			isCorrectPage: true,
			auth: true,
			isPlayAudio:false,
			isStudyTitle:true,//学习中心的头部
		},
	},
	{
		path: '/Book',
		name: 'StudyCenter_Book',
		redirect: '/Book/BookList',
		component: () => import('@/views/StudyCenter/Book/index.vue'),
		meta: {
			isCorrectPage: true,
			auth: false,
			isPlayAudio:false,
			isStudyTitle:true,//学习中心的头部
		},
		children: [
			{
				path: 'BookList',
				name: 'StudyCenter_Book_BookList',
				component: () => import('@/views/StudyCenter/Book/pages/home.vue'),
				meta: {
					isCorrectPage: true,
					auth: false,
					isPlayAudio:false,
					isStudyTitle:true,//学习中心的头部
				},
			},
			{
				path: 'BookFavorite',
				name: 'StudyCenter_Book_BookFavorite',
				component: () => import('@/views/StudyCenter/Book/pages/favorite.vue'),
				meta: {
					isCorrectPage: true,
					auth: false,
					isPlayAudio:false,
					isStudyTitle:true,//学习中心的头部
				},
			}
		]
	},
	{
		path: '/Video',
		name: 'StudyCenter_Video',
		redirect: '/Video/VideoList',
		component: () => import('@/views/StudyCenter/Video/index.vue'),
		meta: {
			isCorrectPage: true,
			auth: false,
			isPlayAudio:false,
			isStudyTitle:true,//学习中心的头部
		},
		children: [
			{
				path: 'VideoList',
				name: 'StudyCenter_Video_VideoList',
				component: () => import('@/views/StudyCenter/Video/pages/home.vue'),
				meta: {
					isCorrectPage: true,
					auth: false,
					isPlayAudio:false,
					isStudyTitle:true,//学习中心的头部
				},
			},
			{
				path: 'VideoFavorite',
				name: 'StudyCenter_Video_VideoFavorite',
				component: () => import('@/views/StudyCenter/Video/pages/favorite.vue'),
				meta: {
					isCorrectPage: true,
					auth: false,
					isPlayAudio:false,
					isStudyTitle:true,//学习中心的头部
				},
			},
			{
				path: 'VideoQuestions',
				name: 'StudyCenter_Video_VideoQuestions',
				component: () => import('@/views/StudyCenter/Video/pages/questions.vue'),
				meta: {
					isCorrectPage: true,
					auth: false,
					isPlayAudio:false,
					isStudyTitle:true,//学习中心的头部
				},
			}
		]
	},
	//侯小草添加
	{
    path: '/studyEvaluate',
    name: 'studyEvaluate',
		component: () => import('@/views/StudyCenter/Evaluation/studyEvaluate.vue'),  // 懒加载
		redirect:'/studyEvaluate/evaluationList',
    meta: {
      isCorrectPage: true,
			auth: false,
			isPlayAudio:false,
			isStudyTitle:true,//学习中心的头部
		},
		children:[
			{
				path: 'evaluationList',
				name: 'evaluationList',
				component: () => import('@/views/StudyCenter/Evaluation/child/evaluationList.vue'),  // 懒加载
				meta: {
					isCorrectPage: true,
					auth: false,
					isPlayAudio:false,
					isStudyTitle:true,//学习中心的头部
				}
			},//学习中心 - 测评-列表
			{
				path: 'evaluateChild',
				name: 'evaluateChild',
				component: () => import('@/views/StudyCenter/Evaluation/child/evaluateChild.vue'),  // 懒加载
				meta: {
					isCorrectPage: true,
					auth: false,
					isPlayAudio:false,
					isStudyTitle:true,//学习中心的头部
				}
			},//学习中心 - 测评
			{
				path: 'ablityAnalyse',
				name: 'ablityAnalyse',
				component: () => import('@/views/StudyCenter/Evaluation/child/ablityAnalyse.vue'),  // 懒加载
				meta: {
					isCorrectPage: true,
					auth: false,
					isPlayAudio:false,
					isStudyTitle:true,//学习中心的头部
				}
			},//学习中心 - 测评-能力指标分析
			{
				path: 'answerResult',
				name: 'answerResult',
				component: () => import('@/views/StudyCenter/Evaluation/child/answerResult.vue'),  // 懒加载
				meta: {
					isCorrectPage: true,
					auth: false,
					isPlayAudio:false,
					isStudyTitle:true,//学习中心的头部
				}
			},//学习中心 - 测评-作答结果
			{
				path: 'record',
				name: 'record',
				component: () => import('@/views/StudyCenter/Evaluation/child/record.vue'),  // 懒加载
				meta: {
					isCorrectPage: true,
					auth: false,
					isPlayAudio:false,
					isStudyTitle:true,//学习中心的头部
				}
			},//学习中心 - 测评-记录 -是个列表
			{
				path: 'wrongAnalysis',
				name: 'wrongAnalysis',
				component: () => import('@/views/StudyCenter/Evaluation/child/wrongAnalysis.vue'),  // 懒加载
				meta: {
					isCorrectPage: true,
					auth: false,
					isPlayAudio:false,
					isWrongAnalyTitle:true,//学习中心 - 测评分析的头部
				}
			},//学习中心 - 测评-记录 -错题分析
		]
  },//学习中心 - 测评
  {
    path: '/subject',
    name: 'subject',
    component: () => import('@/views/StudyCenter/Evaluation/subject.vue'),  // 懒加载
    meta: {
      isCorrectPage: true,
			auth: false,
			isPlayAudio:false,
			isEvalutionTitle:true,//测评期间的头部
    }
  },//学习中心 - 测评-题目
	
]
export default studyCenterRouters;